<template>
  <div class="template">
    <v-img
      :src="require('../assets/landingbg_small.jpg')"
      height="220"
    >
    <div
      class="teaser-image-shader white--text"
      style="padding: 30px; width: 100%"
    >
      <v-row>
          <v-col>
            <h1 class="display-1 font-weight-thin mb-2">
              Join Exposed!
            </h1>
            <h3>It's like bookmarks, but with images</h3>
          </v-col>
      </v-row>
      <v-row>
        <v-btn
          color="black"
          rounded
          dark
          to="/persons"
        >Sign In Now</v-btn>
        <v-btn
          color="white"
          rounded
          outlined
          dark
          class="ml-2"
          to="/"
        >Tell me more</v-btn>
      </v-row>
    </div>
    </v-img>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'signupteaser',
  components: {
  }
}
</script>
